import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20a41c6d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "info_map" }
const _hoisted_2 = {
  key: 0,
  class: "box_scale"
}
const _hoisted_3 = { class: "scale" }
const _hoisted_4 = { class: "position" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    ($data.expand.active)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.expand.position, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["item", [`i_${index+1}`,`i_${item.type}`]])
                }, [
                  _createElementVNode("span", null, _toDisplayString(item.name), 1 /* TEXT */)
                ], 2 /* CLASS */))
              }), 256 /* UNKEYED_FRAGMENT */)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.expand.arrow, (item, index) => {
                return (_openBlock(), _createElementBlock("i", {
                  class: _normalizeClass(["arrow", [`a_${index+1}`,`a_${item}`]])
                }, null, 2 /* CLASS */))
              }), 256 /* UNKEYED_FRAGMENT */))
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}